import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function AlumnoIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("alumno"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Candidato" breadcrumb={["Candidato", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="alumno" />
      </div>
    </AppLayout>
  );
}
